/**
 * Kiosk Configuration Repository
 * Clean wrapper around Kiosk Config API with no business logic
 */

import { KioskConfigApi } from './kiosk-config-api';
import { KioskUICustomization } from '../types/kiosk-types';
import {
  OperatorData,
  GetKioskConfigResponse,
  SaveKioskConfigResponse,
} from '../types/kiosk-api-types';

/**
 * Kiosk Configuration Repository
 * Provides clean interface for data access
 */
export class KioskConfigRepository {
  constructor(private readonly api: KioskConfigApi) {}

  /**
   * Get operator data
   *
   * @param operatorId - Operator ID
   * @returns Operator data
   */
  async getOperator(operatorId: number): Promise<OperatorData> {
    return this.api.getOperator(operatorId);
  }

  /**
   * Get operator settings with UI customization
   *
   * @param operatorId - Operator ID
   * @returns Operator data with parsed UI customization
   */
  async getOperatorSettings(operatorId: number): Promise<GetKioskConfigResponse> {
    return this.api.getOperatorSettings(operatorId);
  }

  /**
   * Save operator settings with UI customization
   *
   * @param operatorId - Operator ID
   * @param uiCustomization - UI customization to save
   * @param notify - Whether to notify users
   * @returns Save result
   */
  async saveOperatorSettings(
    operatorId: number,
    uiCustomization: KioskUICustomization,
    notify?: boolean
  ): Promise<SaveKioskConfigResponse> {
    return this.api.saveOperatorSettings(operatorId, uiCustomization, notify);
  }
}
